module.exports = __webpack_public_path__ + "img/character_resize_sheal.fe27b136.png";